module.exports = __webpack_public_path__ + "static/media/Sandbox Troubleshooting Guide.878e82ae.pdf";